import { Button, Tooltip } from '@shared/components';

interface QSetMarkExamUsageAsReadyButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export default function QSetMarkExamUsageAsReadyButton(
  props: Readonly<QSetMarkExamUsageAsReadyButtonProps>,
) {
  const { disabled, onClick } = props;

  return (
    <Tooltip
      title={disabled ? 'กรุณาเลือกเฉพาะชุดข้อสอบที่อยู่ใน\nสถานะ “Inactive” เท่านั้น' : ''}
      placement='top'
      maxWidth={220}
    >
      <Button
        disabled={disabled}
        size='small'
        color='secondary'
        variant='outlined'
        onClick={onClick}
        sx={{
          '&.Mui-disabled': {
            pointerEvents: 'auto',
          },
        }}
      >
        Mark as Ready
      </Button>
    </Tooltip>
  );
}
